import { baseUrl } from '../../network'

export const getBudgetFiltersUrl = (comapnyId: number) => baseUrl + `api/company/${comapnyId}/budgets/filters`
export const getBudgetsUrl = (comapnyId: number) => baseUrl + `api/company/${comapnyId}/budgets`
export const createBudgetUrl = (companyId: number) => baseUrl + `api/company/${companyId}/budgets`
export const deleteBudgetUrl = (budgetId: number) => baseUrl + `api/company/budget/${budgetId}`
export const getBudgetsOverviewUrl = (comapnyId: number) => baseUrl + `api/company/${comapnyId}/budgets/overview`